export default __webpack_public_path__ + "static/media/luanasmarcon.50133ca2.jpg";